export default __webpack_public_path__ + "static/media/iconbs.8ba9ea91.png";